/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: window.moneyFormat,
            labelAddedToCart: `${window.cartStrings.added_to_cart}`,
            labelCartIsEmpty: `${window.cartStrings.cart_is_empty}`,
            labelQuantity: `${window.cartStrings.quantity}:`,
            labelRemove: `${window.cartStrings.remove}`,
            labelGoToShop: `${window.cartStrings.go_to_shop}`,
            labelError: `${window.cartStrings.error_message}`,
            allProductsCollectionUrl: window.routes.all_products_collection_url,
            hiddenItemTag: 'hidden-product',
            cartDrawerHeaderCounter: '.go-cart-drawer__header_counter',
            cartSectionId: 'cart-drawer'
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;
        this.labelGoToShop = this.defaults.labelGoToShop;
        this.labelError = this.defaults.labelError;
        this.allProductsCollectionUrl = this.defaults.allProductsCollectionUrl;
        this.cartSectionId = this.defaults.cartSectionId;

        this.cartDrawerHeaderCounter = document.querySelector(this.defaults.cartDrawerHeaderCounter);

        this.drawerFocusTrap = window.ThemeFocusTrap && this.cartDrawer
            ? new window.ThemeFocusTrap(this.cartDrawer, {
                initialFocus: this.defaults.cartDrawerClose,
                onEscape: () => {
                    this.closeCartDrawer();
                    this.closeCartOverlay();
                }
            })
            : null;
        this.failModalFocusTrap = window.ThemeFocusTrap && this.cartModalFail
            ? new window.ThemeFocusTrap(this.cartModalFail, {
                initialFocus: this.defaults.cartModalFailClose,
                onEscape: () => {
                    this.closeFailModal();
                    this.closeCartOverlay();
                }
            })
            : null;
        this.cartModalFocusTrap = window.ThemeFocusTrap && this.cartModal
            ? new window.ThemeFocusTrap(this.cartModal, {
                initialFocus: this.defaults.cartModalClose,
                onEscape: () => {
                    this.closeCartModal();
                    this.closeCartOverlay();
                }
            })
            : null;

        // Cache for preloaded images
        this.imageCache = new Map();
        this.cartImagesPreloaded = false;
        this.formErrorIndex = 0;

        this.init();

    }

    setupAtcButtons() {
        if (this.atcButtonsInitialized) return;

        this.atcButtonsInitialized = true;
        document.addEventListener('click', (event) => {
            const item = event.target.closest(this.defaults.addToCart);
            if (!item) return;

            const form = item.closest('form');
            if (!form) return;

            event.preventDefault();

            // Preload product image immediately when ATC is clicked
            const productImageElement = form.querySelector('img[src*="product"], img[data-src*="product"], .product-image img, [class*="product"] img');
            if (productImageElement) {
                const imageSrc = productImageElement.src || productImageElement.dataset.src;
                if (imageSrc) {
                    this.preloadSingleImage(imageSrc);
                }
            }

            this.addItemToCart(form);
        });
    }

    init() {
        this.setupCartItemListeners();

        this.setDrawerDirection();

        this.setupAtcButtons();

        this.cartTrigger.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                this.preloadCartImages();
            });
            
            item.addEventListener('click', (event) => {
                event.preventDefault();
                this.openCartDrawer();
                this.openCartOverlay();
            });
        });

        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            this.closeCartDrawer();
            this.closeCartOverlay();
        });

        this.cartDrawerClose?.addEventListener('click', () => {
            this.closeCartDrawer();
            this.closeCartOverlay();
        });

        this.cartDrawer?.addEventListener('click', (event) => {
            if (!event.target.closest('.js-go-cart-drawer-continue')) return;
            this.closeCartDrawer();
            this.closeCartOverlay();
        });

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.closeFailModal();
                    this.closeCartModal();
                    this.closeCartDrawer();
                    this.closeCartOverlay();
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            this.closeCartDrawer();
            this.closeCartOverlay();
        });

    }

    preloadSingleImage(imageUrl) {
        if (!imageUrl || this.imageCache.has(imageUrl)) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            const img = new Image();
            img.decoding = 'async';
            
            // Store in cache when loaded
            img.onload = () => {
                this.imageCache.set(imageUrl, img);
                if (img.decode) {
                    img.decode().then(() => resolve()).catch(() => resolve());
                } else {
                    resolve();
                }
            };
            
            img.onerror = () => {
                // Silent fail for image preloading
                resolve();
            };
            
            // Set src last to trigger loading
            img.src = imageUrl;
        });
    }

    preloadCartImages() {
        if (this.cartImagesPreloaded) return;
        this.cartImagesPreloaded = true;

        const cartUrl = window.Shopify.routes.root + 'cart.js';
        
        window.fetch(cartUrl, {
            credentials: 'same-origin',
            method: 'GET',
        })
        .then((response) => response.json())
        .then((cart) => {
            if (cart.items && cart.items.length > 0) {
                cart.items.slice(0, 2).forEach((item) => {
                    if (item.image) {
                        this.preloadSingleImage(item.image);
                    }
                });
            }
        })
        .catch((error) => {
            this.cartImagesPreloaded = false;
        });
    }

    fetchCart(callback, sectionHtml = null) {
        const cartRequest = window.fetch(window.Shopify.routes.root + 'cart.js', {
            credentials: 'same-origin',
            method: 'GET',
            headers: { 'Accept': 'application/json' },
        }).then((response) => {
            if (!response.ok) throw new Error(this.labelError);
            return response.json();
        });

        const sectionRequest = sectionHtml
            ? Promise.resolve(sectionHtml)
            : window.fetch(`${window.Shopify.routes.root}cart?section_id=${this.cartSectionId}`, {
                credentials: 'same-origin',
                method: 'GET',
            }).then((response) => {
                if (!response.ok) throw new Error(this.labelError);
                return response.text();
            });

        Promise.all([cartRequest, sectionRequest])
            .then(([cart, renderedSection]) => {
                this.renderCartSection(renderedSection);
                this.fetchHandler(cart, callback);
            })
            .catch(() => {
                this.ajaxRequestFail();
            });
    }

    renderCartSection(sectionHtml) {
        if (!sectionHtml) throw new Error(this.labelError);

        const parsedSection = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const sourceContent = parsedSection.querySelector(this.defaults.cartDrawerContent);
        const sourceFooter = parsedSection.querySelector(this.defaults.cartDrawerFooter);
        const sourceCounter = parsedSection.querySelector(this.defaults.cartDrawerHeaderCounter);

        if (!sourceContent || !sourceFooter || !sourceCounter) {
            throw new Error(this.labelError);
        }

        this.cartDrawerContent.innerHTML = sourceContent.innerHTML;
        this.cartDrawerFooter.innerHTML = sourceFooter.innerHTML;
        this.cartDrawerFooter.classList.toggle('is-invisible', sourceFooter.classList.contains('is-invisible'));
        this.cartDrawerHeaderCounter.innerHTML = sourceCounter.innerHTML;
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.setupCartItemListeners();
    }

    addItemToCart(form) {
        if (!form || form.dataset.cartSubmitting === 'true') return;

        const submitButton = form.querySelector(this.defaults.addToCart);
        const wasDisabled = submitButton?.disabled || false;
        const previousAriaDisabled = submitButton?.getAttribute('aria-disabled');
        const formData = new FormData(form);
        formData.set('sections', this.cartSectionId);
        formData.set('sections_url', window.location.pathname);

        // Lets the product form validate its fields (cancel the event to stop the add)
        // or replace the request body, e.g. to add several items in one request.
        const beforeAdd = new CustomEvent('cart:before-add', {
            bubbles: true,
            cancelable: true,
            detail: { formData, body: null },
        });
        if (!form.dispatchEvent(beforeAdd)) return;

        const body = beforeAdd.detail.body || formData;
        const headers = { 'Accept': 'application/json' };
        if (typeof body === 'string') headers['Content-Type'] = 'application/json';

        form.dataset.cartSubmitting = 'true';
        this.clearAddToCartError(form);

        if (submitButton) {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-disabled', 'true');
        }

        window.fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers,
            body,
        })
        .then((response) => {
            return response.json()
                .catch(() => ({}))
                .then((data) => {
                    if (!response.ok || data.status) {
                        throw new Error(data.description || data.message || this.labelError);
                    }

                    return data;
                });
        })
        .then((product) => {
            // Preload the product image immediately
            if (product.image) {
                this.preloadSingleImage(product.image);
            }

            this.addItemToCartHandler(product);
            form.dispatchEvent(new CustomEvent('cart:item-added', {
                bubbles: true,
                detail: { product },
            }));
        })
        .catch((error) => {
            this.showAddToCartError(form, error.message || this.labelError);
        })
        .finally(() => {
            delete form.dataset.cartSubmitting;

            if (submitButton) {
                submitButton.disabled = wasDisabled;
                if (previousAriaDisabled === null) {
                    submitButton.removeAttribute('aria-disabled');
                } else {
                    submitButton.setAttribute('aria-disabled', previousAriaDisabled);
                }
            }
        });
    }

    clearAddToCartError(form) {
        const errorWrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
        const generatedError = form.querySelector('.go-cart-form-error');
        const submitButton = form.querySelector(this.defaults.addToCart);

        if (errorMessage) errorMessage.textContent = '';
        if (errorWrapper) errorWrapper.hidden = true;
        if (generatedError) {
            generatedError.textContent = '';
            generatedError.hidden = true;
        }
        submitButton?.removeAttribute('aria-invalid');
    }

    showAddToCartError(form, message) {
        const errorWrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        const existingError = errorWrapper?.querySelector('.product-form__error-message');

        if (errorWrapper && existingError) {
            existingError.textContent = message;
            errorWrapper.hidden = false;
            form.querySelector(this.defaults.addToCart)?.setAttribute('aria-invalid', 'true');
            return;
        }

        let errorMessage = form.querySelector('.go-cart-form-error');
        if (!errorMessage) {
            errorMessage = document.createElement('p');
            errorMessage.id = `GoCartFormError-${++this.formErrorIndex}`;
            errorMessage.className = 'form__message go-cart-form-error';
            errorMessage.setAttribute('role', 'alert');
            errorMessage.setAttribute('aria-atomic', 'true');
            form.appendChild(errorMessage);

            const submitButton = form.querySelector(this.defaults.addToCart);
            if (submitButton) {
                const describedBy = new Set((submitButton.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
                describedBy.add(errorMessage.id);
                submitButton.setAttribute('aria-describedby', Array.from(describedBy).join(' '));
            }
        }

        errorMessage.textContent = message;
        errorMessage.hidden = false;
        form.querySelector(this.defaults.addToCart)?.setAttribute('aria-invalid', 'true');
    }
    
    removeItem(itemKey) {
        const quantity = 0;
        window.fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                id: itemKey,
                quantity,
                sections: this.cartSectionId,
                sections_url: window.location.pathname,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
            .then((response) => {
                return response.json()
                    .catch(() => ({}))
                    .then((data) => {
                        if (!response.ok || data.status) {
                            this.showInventoryError(data.description || data.message || this.labelError);
                            this.fetchCart();
                            return null;
                        }

                        return data;
                    });
            })
            .then((data) => {
                if (data) {
                    this.handleCartMutation(data);
                }
            })
            .catch(() => {
                this.showInventoryError(this.labelError);
                this.fetchCart();
            });
    }

    removeItems(itemKeys) {
        const updates = {};
        itemKeys.forEach((key) => {
            updates[key] = 0;
        });

        window.fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                updates,
                sections: this.cartSectionId,
                sections_url: window.location.pathname,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
            .then((response) => {
                return response.json()
                    .catch(() => ({}))
                    .then((data) => {
                        if (!response.ok || data.status) {
                            this.showInventoryError(data.description || data.message || this.labelError);
                            this.fetchCart();
                            return null;
                        }

                        return data;
                    });
            })
            .then((data) => {
                if (data) {
                    this.handleCartMutation(data);
                }
            })
            .catch(() => {
                this.showInventoryError(this.labelError);
                this.fetchCart();
            });
    }

    changeItemQuantity(itemKey, quantity) {
        window.fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                id: itemKey,
                quantity,
                sections: this.cartSectionId,
                sections_url: window.location.pathname,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
            .then((response) => {
                return response.json()
                    .catch(() => ({}))
                    .then((data) => {
                        if (!response.ok || data.status) {
                            this.showInventoryError(data.description || data.message || this.labelError);
                            this.fetchCart();
                            return null;
                        }

                        return data;
                    });
            })
            .then((data) => {
                if (data) {
                    this.handleCartMutation(data);
                }
            })
            .catch(() => {
                this.showInventoryError(this.labelError);
                this.fetchCart();
            });
    }

    handleCartMutation(cart) {
        const sectionHtml = cart.sections?.[this.cartSectionId];
        if (!sectionHtml) {
            this.fetchCart();
            return;
        }

        this.renderCartSection(sectionHtml);
        this.fetchHandler(cart);
    }

    showInventoryError(message) {
        // Create and show inventory error message
        const errorMessage = document.createElement('div');
        errorMessage.className = 'inventory-error-message';
        errorMessage.setAttribute('role', 'alert');
        errorMessage.setAttribute('aria-live', 'assertive');
        errorMessage.setAttribute('aria-atomic', 'true');
        errorMessage.textContent = message;
        document.body.appendChild(errorMessage);
        
        // Remove error message after 4 seconds
        setTimeout(() => {
            if (errorMessage.parentNode) {
                errorMessage.style.animation = 'slideOutRight 0.3s ease';
                setTimeout(() => {
                    if (errorMessage.parentNode) {
                        errorMessage.parentNode.removeChild(errorMessage);
                    }
                }, 300);
            }
        }, 4000);
    }

    cartItemCount(cart) {
        // Update all cart counters on the page
        if (this.cartCount) {
            this.cartCount.forEach(counter => {
                if (counter) {
                    counter.innerHTML = cart.item_count;
                }
            });
        }
        
        // Update cart drawer header counter with localized item label
        if (this.cartDrawerHeaderCounter) {
            const strings = window.cartStrings || {};
            const singular = strings.go_cart_item_singular || 'product';
            const plural = strings.go_cart_item_plural || 'products';
            const productText = cart.item_count === 1 ? singular : plural;

            this.cartDrawerHeaderCounter.innerHTML = ` ${cart.item_count} ${productText}`;
        }
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            this.openCartDrawer();
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);

        if ((typeof callback) === 'function') callback(cart);
    }

    addItemToCartHandler(product) {
        const sectionHtml = product.sections?.[this.cartSectionId];
        if (this.displayModal) return this.fetchAndOpenModal(product);

        return this.fetchCart(() => {
            this.openCartDrawer();
            this.openCartOverlay();
        }, sectionHtml);
    }

    ajaxRequestFail() {
        this.openFailModal();
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ?
            `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>` :
            `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
    }

    setupCartItemListeners() {
        const removeFromCart = this.cartDrawerContent.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                const cartItem = item.closest('.go-cart-item__single');
                if (!cartItem) return;

                GoCart.removeItemAnimation(cartItem);
                const attachedKeys = (cartItem.dataset.attachedKeys || '').split(',').filter(Boolean);
                if (attachedKeys.length) {
                    // Cards and add-ons are only sold with the bouquet, so they go with it.
                    attachedKeys.forEach((key) => {
                        const attachedItem = this.cartDrawerContent.querySelector(`[data-key="${CSS.escape(key)}"]`);
                        if (attachedItem) GoCart.removeItemAnimation(attachedItem);
                    });
                    this.removeItems([cartItem.dataset.key, ...attachedKeys]);
                } else {
                    this.removeItem(cartItem.dataset.key);
                }
            });
        });

        const quantityButtons = this.cartDrawerContent.querySelectorAll(`${this.itemQuantityPlus}, ${this.itemQuantityMinus}`);
        quantityButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const cartItem = button.closest('.go-cart-item__single');
                const quantityInput = cartItem?.querySelector(this.itemQuantity);
                if (!cartItem || !quantityInput) return;

                const change = Number(button.dataset.quantityChange);
                const quantity = Number(quantityInput.value) + change;
                this.changeItemQuantity(cartItem.dataset.key, quantity);
            });
        });
    }

    reloadAjaxContent() {
        this.fetchAndOpenCart();
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
        this.cartDrawer.setAttribute('aria-hidden', 'false');
        document.querySelector('body').classList.add('drawer-open');
        this.drawerFocusTrap?.activate();
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
        this.cartDrawer.setAttribute('aria-hidden', 'true');
        document.querySelector('body').classList.remove('drawer-open');
        this.drawerFocusTrap?.deactivate();
    }

    openFailModal() {
        this.cartModalFail.hidden = false;
        this.cartModalFail.classList.add('is-open');
        this.failModalFocusTrap?.activate();
    }

    closeFailModal() {
        this.cartModalFail.classList.remove('is-open');
        this.cartModalFail.hidden = true;
        this.failModalFocusTrap?.deactivate();
    }

    openCartModal() {
        this.cartModal.hidden = false;
        this.cartModal.classList.add('is-open');
        this.cartModalFocusTrap?.activate();
    }

    closeCartModal() {
        this.cartModal.classList.remove('is-open');
        this.cartModal.hidden = true;
        this.cartModalFocusTrap?.deactivate();
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }
}

//export default GoCart;
